<template>
  <!-- TODO add loading spinner animation while applicationReady is not ready -->
  <t-content main class="tournaments-view" v-if="applicationReady" data-qe-id="tournaments-view">
    <c-tournament-header :zone="zoneId" :language="$i18n.locale" />
    <c-navigation>
      <router-link to="/" data-qe-id="back-to-zone-overview-link">{{ $t('tViews.main.button_back') }}</router-link>
      <template v-slot:tabs>
        <c-tournaments-selection
          v-if="tournamentsSelections.length > 1"
          @action="chooseTournament"
          :tournaments-selections="tournamentsSelections"
          :selected-t-id="store.state.tournament.tournamentId"
        ></c-tournaments-selection>
      </template>
    </c-navigation>
    <div>
      <div v-if="hasTournaments">
        <m-tournament />
      </div>
      <c-tournaments-not-available v-else @goBack="router.push('/')" />
    </div>
    <t-container>
      <m-ranking-section />
      <c-masters-qualification-info v-if="store.getters.isMastersSelected" class="masters-info" />
    </t-container>
  </t-content>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store'
import MTournament from '@/modules/MTournament.vue'
import MRankingSection from '@/modules/MRankingSection.vue'
import CTournamentHeader from '@/components/CTournamentHeader.vue'
import CNavigation from '@/components/CNavigation.vue'
import CTournamentsSelection, { TournamentsSelections } from '@/components/CTournamentsSelection.vue'
import CMastersQualificationInfo from '@/components/CMastersQualificationInfo.vue'
import CTournamentsNotAvailable from '@/components/CTournamentsNotAvailable.vue'
import { ERROR_CODES } from '@/model/ErrorCodes'

const props = defineProps<{ tId: string; zoneId: string }>()
const emit = defineEmits(['close'])
const router = useRouter()
const route = useRoute()
const store = useStore()
const applicationReady = ref(false)

// vue js live cycle method:
onMounted(() => {
  store
    .dispatch('fetchTournament', props.zoneId)
    .then(() => {
      if (props.tId) {
        // if there is a preselcted from URL we load them
        store.commit('setActiveTournament', props.tId)
      } else if (store.state.zone.tournaments.length > 0) {
        store.commit('setActiveTournament', store.state.zone.tournaments[0].tournamentId)
      }
      applicationReady.value = true
    })
    .catch((err: any) => {
      if (err && err.errorCode === 401) {
        router.replace('/extern/login')
      } else {
        router.push({ path: `/error/${(err && err.errorCode) || ERROR_CODES.UNKNOWN}/${props.zoneId}` })
      }
    })

  // scroll to focus
  // not when history is active - otherwise we have jumping page because of scrolling inside MRankingSection
  // ( it was not possible to add the scrolling here because the MRankingSection is not rendered at this time )
  if (route.query.table !== 'history') {
    document.getElementById('app').scrollIntoView({ behavior: 'smooth' })
  }
})

function chooseTournament(tId: string) {
  try {
    store.commit('setActiveTournament', tId)
    router.push(`/tournaments/${props.zoneId}/${tId}`).catch((err) => {})
  } catch (err: any) {
    console.error('Can select specific tournament with ID', tId)
    router.push('/error/' + err.errorCode)
  }
}

const hasTournaments = computed(() => {
  return store.state.zone.tournaments.length > 0
})

const tournamentsSelections = computed((): Array<TournamentsSelections> => {
  return store.state.zone.tournaments
})
</script>

<style scoped lang="less">
.tournaments-view {
  padding-bottom: 5.625em;
}
section {
  margin: auto;
  width: 50%;
}
.info-headline {
  text-align: center;
}
.masters-info {
  margin: 5em auto 0;
}
.table-title {
  margin-bottom: 1.2em;
}
</style>
